module.exports = __webpack_public_path__ + "static/media/73.da97b2a0.jpg";